import axios from 'axios';
import FormData from 'form-data';

export class RepresentativesWidgetRepository {
	constructor() {
		this.initAttributes();
	}

	initAttributes() {
		this.ajaxUrl = '/wp-admin/admin-ajax.php';
	}

	async getFilteredRepresentatives(regionId, lineOfBusinessId, searchValue) {
		const ajaxUrl = this.ajaxUrl;

		const data = {
			action: 'representatives_widget_get_filtered_data',
			regionId,
			lineOfBusinessId,
			searchValue
		};

		const formData = new FormData();

		for (const key in data) {
			formData.append(key, data[key]);
		}

		return new Promise((resolve, reject) => {
			axios({
				method: 'post',
				url: ajaxUrl,
				data: formData,
				headers: { 'Content-Type': 'multipart/form-data' },
			}).then(
				(response) => {
					resolve(response.data);
				},
				(error) => {
					resolve();
				}
			);
		});
	}
}
